import { DiToken, registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

export type EnvFe = {
  feApiUrl: string;
};

// biome-ignore lint/style/useNamingConvention: must be with underscore
export const ENV_FE: DiToken<EnvFe> = new DiToken<EnvFe>('EnvFe');

export function registerEnvFe(envFe: EnvFe): void {
  registerDiToken(ENV_FE, () => envFe);
}
